import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Job } from '../../../../../../../shared/Jobbing/models/Job';

@Component({
  selector: 'app-notification-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './notification-form.component.html',
  styleUrl: './notification-form.component.scss'
})
export class NotificationFormComponent implements OnInit {

  @Input()
  formGroup!: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.addControl('notification', this.fb.group({
      email: this.fb.group({
        name: this.fb.control(''),
        address: this.fb.control('', [Validators.email]),
      }),
      mobile: this.fb.group({
        name: this.fb.control(''),
        number: this.fb.control(''),
      }),
    }));
  }

  getFormGroup() {
    if (!this.formGroup.get('notification')) {
      this.initializeForm();
    }
    return this.formGroup.get('notification') as FormGroup;
  }
}
